import React, { Component } from 'react';
import DashNav from '../components/header/nave';
import MenuNav from './Menu/Menu';
import { Route } from 'react-router-dom';
import { routerlist } from "../features/PortalRoutes";
import { Layout, Affix } from 'antd';
import 'antd/dist/antd.css';

const { Content } = Layout;

class Main extends Component {
        constructor(props) {
                super(props)
                this.state = {
                        isOpen: true
                }
        }

        getHandleOpen = (status) => {
                this.setState({ isOpen: status })
        }

        goBack = ()=>{
                this.props.history.push('/storeList')
        }


        render() {
                return <Layout>
                        <Affix offsetTop={0}>
                                <DashNav goBack={this.goBack} />
                        </Affix>
                        <Layout style={{ justifyContent: 'space-between', }}>
                                <MenuNav isOpen={this.state.isOpen} history={this.props.history} />
                                <Layout >
                                        <Content style={{ padding: "24px" }}>
                                                {routerlist.map((data, index) => {
                                                        return <Route exact={data.exact} path={data.path} key={index} component={data.component}></Route>
                                                })}
                                        </Content>
                                </Layout>
                        </Layout>
                </Layout>
        }
}

export default Main;